import { Model as p } from "../../../../model.js";
class a extends p {
  constructor(d) {
    super(), this.status = d.status, this.timestamp = d.timestamp, this.amount = d.amount, this.currency = d.currency, this.tip = d.tip, this.fee = d.fee, this.estimatedFee = d.estimatedFee, this.paymentId = d.paymentId, this.paymentType = d.paymentType, this.paymentSubtype = d.paymentSubtype, this.paymentMethodType = d.paymentMethodType, this.paymentMethodEngineType = d.paymentMethodEngineType, this.cardBrand = d.cardBrand, this.cardFunding = d.cardFunding, this.cardCountryCode = d.cardCountryCode, this.cardDetails = d.cardDetails;
  }
}
export {
  a as TicketHistoryPaymentModel
};
//# sourceMappingURL=ticketHistoryPayment.model.js.map
